import React, { useState, useEffect } from "react";
import { Collapse, Container, NavbarToggler, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { get } from "lodash";

import logolight from "../../../assets/images/logo-light.png";
import i18n from "../../../i18n";
import languages from "../../../common/languages";

const Navbar = () => {
    const { t } = useTranslation();
    const [isOpenMenu, setisOpenMenu] = useState(false);
    const [navClass, setnavClass] = useState("");
    const [selectedLang, setSelectedLang] = useState("");
    const [isLanguageDropdown, setIsLanguageDropdown] = useState(false);

    useEffect(() => {
        const currentLanguage = localStorage.getItem("I18N_LANGUAGE") || "pl";
        setSelectedLang(currentLanguage);
    }, []);

    const changeLanguageAction = lang => {
        i18n.changeLanguage(lang);
        localStorage.setItem("I18N_LANGUAGE", lang);
        setSelectedLang(lang);
    };

    const toggleLanguageDropdown = () => {
        setIsLanguageDropdown(!isLanguageDropdown);
    };

    const toggle = () => setisOpenMenu(!isOpenMenu);

    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });

    const scrollNavigation = () => {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setnavClass("is-sticky");
        } else {
            setnavClass("");
        }
    }

    const [activeLink, setActiveLink] = useState();
    useEffect(() => {
        const activation = (event) => {
            const target = event.target;
            if (target) {
                target.classList.add('active');
                setActiveLink(target);
                if (activeLink && activeLink !== target) {
                    activeLink.classList.remove('active');
                }
            }
        };
        const defaultLink = document.querySelector('.navbar li.a.active');
        if (defaultLink) {
            defaultLink?.classList.add("active")
            setActiveLink(defaultLink)
        }
        const links = document.querySelectorAll('.navbar a');
        links.forEach((link) => {
            link.addEventListener('click', activation);
        });
        return () => {
            links.forEach((link) => {
                link.removeEventListener('click', activation);
            });
        };
    }, [activeLink]);

    return (
        <React.Fragment>
            <nav className={"navbar navbar-expand-lg navbar-landing fixed-top " + navClass} id="navbar">
                <Container>
                    <NavLink className="navbar-brand" href="#home">
                        <img src={logolight} className="card-logo card-logo-light" alt="logo light" height="26" />
                    </NavLink>

                    <NavbarToggler className="navbar-toggler py-0 fs-20 text-body" onClick={toggle} type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <i className="mdi mdi-menu"></i>
                    </NavbarToggler>

                    <Collapse
                        isOpen={isOpenMenu}
                        className="navbar-collapse"
                        id="navbarSupportedContent"
                    >
                        <Scrollspy
                            offset={-18}
                            items={[
                                "home",
                                "features",
                                "contact",
                            ]}
                            currentClassName="active"
                            className="navbar-nav mx-auto mt-2 mt-lg-0"
                            id="navbar-example"
                        >
                            <li className="nav-item">
                                <NavLink href="#home"><strong>{t('landing.nav.home')}</strong></NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink href="#features">{t('landing.nav.features')}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink href="#contact">{t('landing.nav.contact')}</NavLink>
                            </li>
                        </Scrollspy>

                        <div className="d-flex align-items-center gap-2">
                            <Dropdown isOpen={isLanguageDropdown} toggle={toggleLanguageDropdown}>
                                <DropdownToggle className="btn btn-icon btn-ghost-secondary rounded-circle fw-semibold" tag="button" title={t('Language')}>
                                    <span className="fs-14">{get(languages, `${selectedLang}.code`) || ''}</span>
                                </DropdownToggle>
                                <DropdownMenu className="notify-item language py-2">
                                    {Object.keys(languages).map(key => (
                                        <DropdownItem
                                            key={key}
                                            onClick={() => changeLanguageAction(key)}
                                            className={`notify-item ${selectedLang === key ? "active" : ""}`}
                                        >
                                            <span className="badge bg-light text-body fw-semibold me-2">
                                                {get(languages, `${key}.code`)}
                                            </span>
                                            <span className="align-middle">
                                                {get(languages, `${key}.label`)}
                                            </span>
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                            <Link to="/admin/login" className="btn btn-link fw-medium text-decoration-none text-body">{t('landing.nav.login')}</Link>
                            <Link to="/register" className="btn btn-primary">{t('Try for Free')}!</Link>
                        </div>
                    </Collapse>
                </Container>
            </nav>
        </React.Fragment>
    );
};

export default Navbar;
